<h2 mat-dialog-title>{{ texts.title }}</h2>

<mat-dialog-content>
  @for (paragraph of texts.paragraphs; track $index) {
    <p class="fast-track-info-paragraph">{{ paragraph }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton="filled" data-testid="fast-track-next" mat-dialog-close>{{ texts.nextLabel }}</button>
</mat-dialog-actions>
